import React from 'react';
import ServicePage from '../components/ServicePage';
import img from '../assets/service9_1.jpeg';

const overview = [
  'Flexible IT financing solutions including operating and finance leases, structured payment plans, technology upgrades, asset management, and scalable investment support.'
];

const features = [
  { title: 'IT Equipment Leasing',  text: 'Flexible leasing options for hardware and software' },
  { title: 'Flexible Payment Plans', text: 'Customized payment schedules aligned with your budget' },
  { title: 'Technology Refresh',    text: 'Regular upgrade programs to keep your technology current' },
  { title: 'Asset Management',      text: 'Complete lifecycle management of IT assets' }
];

function FinancialService() {
  return (
    <ServicePage
      title="Financial Services"
      subtitle="Flexible financing solutions for IT infrastructure"
      img={img}
      imgAlt="Financial Services"
      overview={overview}
      features={features}
      backAnchor="financial"
    />
  );
}

export default FinancialService;
